import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const SystemOfLinearEquations = () => (
  <QPhototModuleSubtopic
    title="System of Linear Equations"
    videos={[
      "https://www.youtube.com/embed/Ig_u4DY26QE",
      "https://www.youtube.com/embed/AMr5etyUEL8",
      "https://www.youtube.com/embed/gPOL-hwzIUc",
      "https://www.youtube.com/embed/6n7tub_20J0"
    ]}
    takeaways={[]}
    questions={[
        {image:"/cvla_46.png"},
        {image:"/cvla_47.png"},
        {image:"/cvla_48.png"},
        {image:"/cvla_49.png"},
        {image:"/cvla_50.png"},
        {image:"/cvla_51.png"},
        {image:"/cvla_52.png"},
        {image:"/cvla_53.png"},
    ]}
    exampleVideos={[]}
  />
);

export default SystemOfLinearEquations;
